import {Component, OnInit} from '@angular/core';

import {LoginService} from './login/login.service';
import {EventEmiterService} from './shared/event-emiter.service';

import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  isLogged;
  showTemplate = true;
  cardTitle: string;
  cardPadding = true;

  constructor(private eventEmiterService: EventEmiterService,
    private loginService: LoginService, router: Router) {

        //Google analytcs
        const navEndEvents = router.events.pipe(
        filter(event => event instanceof NavigationEnd),
      );
      navEndEvents.subscribe((event: NavigationEnd) => {
        gtag('config', 'UA-118279167-2', {
              'page_path': event.urlAfterRedirects
        });
      });
    }

  ngOnInit() {
    // NOTE Define os títulos dos cards
    this.eventEmiterService.dataStr.subscribe(
      response => setTimeout(() => this.cardTitle = response, 0));

    // NOTE Define se o card terá padding ou não
    this.eventEmiterService.dataPadding.subscribe(
      response => setTimeout(() => this.cardPadding = response, 0));

    // NOTE Desativa o template base caso o módulo queira
    this.eventEmiterService.showTemplate.subscribe(
      response => setTimeout(() => this.showTemplate = response, 0));

    // NOTE Verifica se o usuário está logado
    this.loginService.isLoggedIn().subscribe(
      response => setTimeout(() => this.isLogged = response, 0));
  }
}
